import NextProject from './NextProject';

export default NextProject;
